import { useState } from "react";
import {
  DashboardContainer,
  TabWrapper,
  TapItem,
  TapMenuBox,
  TapMenuItem,
  TapMenuWrapper,
  UnderLine,
} from "style/admin/dashboard";
import { AnimatePresence, motion } from "framer-motion";
import DashboardCumulativeStatistics from "./children/dashboard.cumulative.statistics";
import DashboardMultiStatistics from "./children/dashboard.multi.statistics";

const AdminDashboardHome = () => {
  const [tap, setTap] = useState(0);
  const [searchInput, setSearchInput] = useState(""); // ✅ 입력값 상태
  const [searchTerm, setSearchTerm] = useState(""); // ✅ API 요청을 위한 상태
  const [dataLengths, setDataLengths] = useState<{ [key: number]: boolean }>({
    0: false,
    1: false,
    // 2: false,
  }); // ✅ 각 탭별로 dataLength 저장

  // ✅ 탭 변경 핸들러
  const menuHandler = (idx: number) => {
    setTap(idx);
    setSearchInput("");
    setSearchTerm("");
  };

  return (
    <DashboardContainer>
      <TapMenuWrapper>
        <TapMenuBox>
          {["누적 이용 통계", "기간별 이용 통계"].map((menu, index) => (
            <TapMenuItem
              key={index}
              onClick={() => menuHandler(index)}
              className={tap === index ? "isActive" : ""}
              layout
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            >
              <motion.span transition={{ duration: 0.3 }} className="manu-name">
                {menu}
                {/* ✅ 탭이 0번일 때만 dot을 표시하고, 데이터가 존재할 경우 유지 */}
                {index === 0 && dataLengths[0] && <span className="dot"></span>}
              </motion.span>

              {tap === index && (
                <UnderLine
                  layoutId="underline"
                  className="underline"
                  transition={{ type: "spring", stiffness: 300, damping: 20 }}
                />
              )}
            </TapMenuItem>
          ))}
        </TapMenuBox>
      </TapMenuWrapper>

      <TabWrapper>
        <AnimatePresence mode="wait" initial={false}>
          {tap === 0 && (
            <TapItem
              key={0}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            >
              <DashboardCumulativeStatistics />
            </TapItem>
          )}
          {tap === 1 && (
            <TapItem
              key={1}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            >
              <DashboardMultiStatistics />
            </TapItem>
          )}
          {/* {tap === 2 && (
            <TapItem
              key={2}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            ></TapItem>
          )} */}
        </AnimatePresence>
      </TabWrapper>
    </DashboardContainer>
  );
};

export default AdminDashboardHome;
